import React, { Component } from 'react'

import { Container } from 'components/Layout'
import HeadingBanner from 'components/Text/HeadingBanner'
import BillingAccountForm from '../BillingAccountForm'

import sText from 'components/Text/Text.scss'
import cn from 'classnames'

export default class BillingCreateFormModal extends Component {
  state = {
    heading: 'Create a Billing Account',
    subHeading: '',
  }

  setHeadings = (heading, subHeading) => {
    this.setState({
      heading,
      subHeading,
    })
  }

  render() {
    const { modalConfirm, modalCancel } = this.props
    const { heading, subHeading } = this.state

    return (
      <div>
        <HeadingBanner filled>
          <h3 className={cn(sText.heading3, sText.accent)}>{heading}</h3>
          <div className={sText.descrip2}>{subHeading}</div>
        </HeadingBanner>

        <Container paddingTop paddingBottom className="sm">
          <BillingAccountForm
            onCancel={modalCancel}
            afterSubmit={modalConfirm}
            setHeadings={this.setHeadings}
          />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingCreateFormModal/BillingCreateFormModal.jsx